
import {
  setReportData,
  setLoading,
  setError,
} from "../../../redux/comparativeDashSlice";

export const fetchComparativeData =
  async ({
    endpoint,
    reportKey,
    CompCode,
    FinYear,
    UserID,
    extraParams,
    dispatch,
    callFetch,
    setLoading: setLocalLoading,
  }: any) => {

    dispatch(setLoading(true));

    setLocalLoading(true);

    try {

      const queryParams =
        new URLSearchParams({
          CompCode: String(CompCode),
          FY: String(FinYear),
          UserID: String(UserID),
          ...extraParams,
        }).toString();

      const finalUrl =
        `${endpoint}?${queryParams}`;

      console.log(
        "FINAL API URL =>",
        finalUrl
      );

      const { got } =
        await callFetch(
          finalUrl,
          "GET"
        );

      console.log(
        "REAL API DATA =>",
        got
      );

      if (got?.Status === 1) {

        dispatch(
          setReportData({
            key: reportKey,
            data: got,
          })
        );

      } else {

        throw new Error(
          got?.Msg || "Fetch Error"
        );
      }

    } catch (err: any) {

      console.log(
        "API ERROR =>",
        err
      );

      dispatch(
        setError(err.message)
      );

    } finally {

      dispatch(setLoading(false));

      setLocalLoading(false);
    }
  };